import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Badge } from '../components/Badge';
import { Mail, MessageSquare, ChevronDown, ChevronUp, Users, MousePointerClick, Reply } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const CAMPAIGNS = [{
  id: 1,
  name: 'First-Time Buyer Nurture',
  type: 'email',
  enrolled: 124,
  openRate: '45%',
  clickRate: '12%',
  replyRate: '4%',
  status: 'active',
  steps: [{
    day: 1,
    subject: "Welcome to homebuying! Let's get started.",
    channel: 'email'
  }, {
    day: 3,
    subject: 'Understanding pre-approval vs pre-qualification',
    channel: 'email'
  }, {
    day: 7,
    subject: 'Top 5 mistakes first-time buyers make',
    channel: 'email'
  }, {
    day: 14,
    subject: 'Ready to look at houses? Here is a checklist.',
    channel: 'email'
  }]
}, {
  id: 2,
  name: 'Rate Drop Alert',
  type: 'sms',
  enrolled: 89,
  openRate: '98%',
  clickRate: '45%',
  replyRate: '22%',
  status: 'active',
  steps: [{
    day: 1,
    subject: 'Hi [Name], rates just dropped to [Rate]%. Call me if you want to lock this in!',
    channel: 'sms'
  }]
}, {
  id: 3,
  name: 'Post-Closing Follow-up',
  type: 'mixed',
  enrolled: 45,
  openRate: '68%',
  clickRate: '15%',
  replyRate: '8%',
  status: 'paused',
  steps: [{
    day: 30,
    subject: 'Happy 1-month anniversary in your new home!',
    channel: 'email'
  }, {
    day: 180,
    subject: 'Checking in - how is the house?',
    channel: 'sms'
  }, {
    day: 365,
    subject: "Happy 1-year homeversary! Let's review your equity.",
    channel: 'email'
  }]
}];
export function Campaigns() {
  const [expanded, setExpanded] = useState<number | null>(null);
  return <Layout data-id="element-221">
      <div className="max-w-7xl mx-auto space-y-6" data-id="element-222">
        <div className="flex justify-between items-end" data-id="element-223">
          <div data-id="element-224">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-225">Campaigns</h1>
            <p className="text-slate-500 mt-1" data-id="element-226">
              Manage your automated email and SMS sequences.
            </p>
          </div>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm" data-id="element-227">
            Create Campaign
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-228">
          {CAMPAIGNS.map(c => <div key={c.id} className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden transition-all hover:border-slate-300" data-id="element-229">
              <div className="p-6 flex flex-col md:flex-row md:items-center justify-between cursor-pointer gap-4" onClick={() => setExpanded(expanded === c.id ? null : c.id)} data-id="element-230">
                <div className="flex items-center gap-4" data-id="element-231">
                  <div className={`p-3 rounded-xl ${c.type === 'email' ? 'bg-blue-50 text-blue-600' : c.type === 'sms' ? 'bg-purple-50 text-purple-600' : 'bg-slate-100 text-slate-600'}`} data-id="element-232">
                    {c.type === 'email' ? <Mail size={24} data-id="element-233" /> : c.type === 'sms' ? <MessageSquare size={24} data-id="element-234" /> : <Mail size={24} data-id="element-235" />}
                  </div>
                  <div data-id="element-236">
                    <div className="flex items-center gap-2" data-id="element-237">
                      <h3 className="text-lg font-semibold text-slate-900" data-id="element-238">
                        {c.name}
                      </h3>
                      <Badge variant={c.status === 'active' ? 'success' : 'default'} data-id="element-239">
                        {c.status}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 mt-1.5 text-sm text-slate-500" data-id="element-240">
                      <span className="flex items-center gap-1.5" data-id="element-241">
                        <Users size={14} data-id="element-242" /> {c.enrolled} enrolled
                      </span>
                      <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-243" />
                      <span data-id="element-244">{c.steps.length} steps</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-8 md:ml-auto mr-4" data-id="element-245">
                  <div className="text-center" data-id="element-246">
                    <div className="text-lg font-semibold text-slate-900" data-id="element-247">
                      {c.openRate}
                    </div>
                    <div className="text-xs text-slate-500 flex items-center gap-1" data-id="element-248">
                      <Mail size={12} data-id="element-249" /> Open
                    </div>
                  </div>
                  <div className="text-center" data-id="element-250">
                    <div className="text-lg font-semibold text-slate-900" data-id="element-251">
                      {c.clickRate}
                    </div>
                    <div className="text-xs text-slate-500 flex items-center gap-1" data-id="element-252">
                      <MousePointerClick size={12} data-id="element-253" /> Click
                    </div>
                  </div>
                  <div className="text-center" data-id="element-254">
                    <div className="text-lg font-semibold text-slate-900" data-id="element-255">
                      {c.replyRate}
                    </div>
                    <div className="text-xs text-slate-500 flex items-center gap-1" data-id="element-256">
                      <Reply size={12} data-id="element-257" /> Reply
                    </div>
                  </div>
                </div>

                <div className="hidden md:block p-2 text-slate-400 hover:bg-slate-100 rounded-full transition-colors" data-id="element-258">
                  {expanded === c.id ? <ChevronUp size={20} data-id="element-259" /> : <ChevronDown size={20} data-id="element-260" />}
                </div>
              </div>

              <AnimatePresence data-id="element-261">
                {expanded === c.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="bg-slate-50 border-t border-slate-100 overflow-hidden" data-id="element-262">
                    <div className="p-6" data-id="element-263">
                      <h4 className="font-medium text-slate-900 mb-4" data-id="element-264">
                        Sequence Steps
                      </h4>
                      <div className="space-y-3 relative before:absolute before:inset-0 before:ml-[1.1rem] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-slate-200" data-id="element-265">
                        {c.steps.map((step, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group" data-id="element-266">
                            <div className="flex items-center justify-center w-9 h-9 rounded-full border-4 border-slate-50 bg-white text-slate-500 shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-267">
                              {step.channel === 'email' ? <Mail size={14} data-id="element-268" /> : <MessageSquare size={14} data-id="element-269" />}
                            </div>
                            <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-270">
                              <div className="flex items-center justify-between mb-2" data-id="element-271">
                                <Badge variant="default" data-id="element-272">Day {step.day}</Badge>
                                <span className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-273">
                                  {step.channel}
                                </span>
                              </div>
                              <p className="text-sm text-slate-700 font-medium" data-id="element-274">
                                {step.subject}
                              </p>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Layout>;
}